<template>
  <canvas class="noise" ref="noise" />
</template>

<script>
import Aion from '@adoratorio/aion';

export default {
  name: 'grain',

  mounted() {
    this.init();
    this.setup();
  },

  methods: {
    init() {
      this.canvas = this.$refs.noise;
      this.ctx = this.canvas.getContext('2d', { alpha: false });
      this.scaleFactor = 2;

      this.noiseData = [];
      this.frame = 0;

      this.loopTimeout = null;
      this.resizeThrottle = null;

      this.setup();
    },

    setup() {
      this.noiseData = [];
      this.canvas.width = window.innerWidth / this.scaleFactor;
      this.canvas.height = window.innerHeight / this.scaleFactor;

      for (let i = 0; i < 10; i += 1) {
        this.createNoise();
      }

      const loop = new Aion();
      loop.add(() => this.paintNoise(this.frame), 'noise', true);
      loop.start();
    },

    createNoise() {
      const idata = this.ctx.createImageData(window.innerWidth / this.scaleFactor, window.innerHeight / this.scaleFactor);
      const buffer32 = new Uint32Array(idata.data.buffer);
      const len = buffer32.length;

      for (let i = 0; i < len; i += 1) {
        if (Math.random() < 0.5) {
          buffer32[i] = 0xff000000;
        }
      }

      this.noiseData.push(idata);
    },

    paintNoise() {
      if (this.frame === 9) {
        this.frame = 0;
      } else {
        this.frame += 1;
      }

      this.ctx.putImageData(this.noiseData[this.frame], 0, 0);
    },
  },
};
</script>

<style scoped>
.noise {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  opacity: 0.018;
  pointer-events: none;
}
</style>
